import React, { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

const OptionInputReason = (props) => {
  const { placeholder, data, filter,setFilter } = props;
  const [selected, setSelected] = useState("");
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full border h-[40px]  border-[#CBD5E1]  rounded-lg font-medium ">
      <div
        onClick={() => setOpen(!open)}
        className={` w-full h-[40px] p-2 flex text-sm text-[#6C757D] items-center justify-between rounded-lg ${
          !selected && "text-[#6C757D]"
        }`}
      >
        {selected
          ? selected?.length > 25
            ? selected?.substring(0, 25) + "..."
            : selected
          : placeholder}
        <ChevronDownIcon className={` h-4 ${open && "rotate-180  h-4 "}`} />
      </div>
      <ul
        style={{ boxShadow: "0px 0px 4px 0px #00000040" }}
        className={` relative bg-white mt-2 overflow-y-auto z-40  rounded-lg ${
          open ? "max-h-60" : "max-h-0"
        } `}
      >
        {data?.map((item) => {

         return (<li
            key={item.id}
            className={`p-2 text-sm cursor-pointer  hover:bg-[#2563EB] hover:text-white
           `}
            onClick={() => {
             if(placeholder === "Select Your Reason" &&  item?.reason?.toLowerCase() !== selected?.toLowerCase() ){
                setSelected(item?.reason);
                setOpen(false);
                if(item.id !==7) setFilter({...filter, disabled:false, reasonDropDown:item})
                else setFilter({...filter, disabled:true, reasonDropDown:item})
              }
            }} 
          >
        { item.reason}
        
         </li>)
})}
      </ul>
    </div>
  );
};

export default OptionInputReason;